import { render, staticRenderFns } from "./IconMenuAudience.vue?vue&type=template&id=60bf196e&"
import script from "./IconMenuAudience.vue?vue&type=script&lang=js&"
export * from "./IconMenuAudience.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60bf196e')) {
      api.createRecord('60bf196e', component.options)
    } else {
      api.reload('60bf196e', component.options)
    }
    module.hot.accept("./IconMenuAudience.vue?vue&type=template&id=60bf196e&", function () {
      api.rerender('60bf196e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconMenuAudience.vue"
export default component.exports